// Slice RTK per `state.tripGroups` = `{ list, lastFetchedDay }`.
// Variante dello stream pattern: niente `unsubscribe` esposto, ma `lastFetchedDay`
// per evitare refetch ridondanti dello stesso giorno.

import { createSlice } from '@reduxjs/toolkit';

const initialState = { list: [], lastFetchedDay: null };

const tripGroupsSlice = createSlice({
  name: 'tripGroups',
  initialState,
  reducers: {
    received: (state, action) => {
      const { list, day } = action.payload ?? {};
      state.list = list ?? [];
      state.lastFetchedDay = day ?? null;
    },
    listenerStopped: () => initialState,
  },
});

export const tripGroupsActions = tripGroupsSlice.actions;
export default tripGroupsSlice.reducer;
